<template>
    <Loader :show="loading" />
    <Layout />
    <GlobalModal />
    <BankIdFaker />
</template>

<script>
    import { computed, onBeforeUnmount, onMounted } from 'vue';
    import { useStore } from 'vuex';
    import { useRouter } from 'vue-router';
    import { authUser, SESSION_EXPIRED_EVENT, SYSTEM_ERROR_EVENT } from '@/helpers';
    import { clearToken } from '@/System/Store/Api/ApiUser';
    import GlobalModal from '@components/Modal/GlobalModal.vue';
    import Layout from './System/Views/Layout';
    import BankIdFaker from './System/Compenents/BankId/BankIdFaker';
    import Loader from '@components/Loader/Loader';
    import markerSDK from '@marker.io/browser';

    export default {
        components: {
            Layout,
            Loader,
            BankIdFaker,
            GlobalModal,
        },
        setup() {
            const store = useStore();
            const router = useRouter();

            if (process.env.NODE_ENV !== 'production' && /.*\.(com|se)$/.test(window.location.hostname)) {
                markerSDK.loadWidget({
                    destination: '66d03835d6f614aa4872a9c1',
                });

                console.log(
                    '%c Cervd System booted!',
                    'font-weight: bold; font-size: 50px;color: red; text-shadow: 3px 3px 0 rgb(217,31,38) , 6px 6px 0 rgb(226,91,14) , 9px 9px 0 rgb(245,221,8) , 12px 12px 0 rgb(5,148,68) , 15px 15px 0 rgb(2,135,206) , 18px 18px 0 rgb(4,77,145) , 21px 21px 0 rgb(42,21,113)'
                );
            }

            const loading = computed(() => store.getters['GlobalStore/GET_LOADING']);

            const eventListener = (event) => {
                if ('detail' in event) {
                    const snackbar =
                        typeof event.detail === 'object'
                            ? event.detail
                            : {
                                  message: event.detail,
                                  status: 'Warning',
                              };
                    store.dispatch('GlobalStore/SET_SNACKBAR', snackbar);
                }
            };

            /**
             * The cached session was removed (expired or corrupt) while the app was running.
             * Bring the in-memory state back in sync so nothing acts on the stale login, and
             * send the user to the login page if they were on an authenticated route.
             */
            const sessionExpiredListener = () => {
                clearToken();
                store.dispatch('GlobalStore/RESET_STORES');

                const current = router.currentRoute.value;

                if (current.name !== 'login' && current.meta?.requiresAuth) {
                    router.replace({ name: 'login', query: { redirect: encodeURIComponent(current.fullPath) } });
                }
            };

            onBeforeUnmount(() => {
                window.removeEventListener(SYSTEM_ERROR_EVENT, eventListener);
                window.removeEventListener(SESSION_EXPIRED_EVENT, sessionExpiredListener);
            });

            onMounted(async () => {
                window.addEventListener(SYSTEM_ERROR_EVENT, eventListener);
                window.addEventListener(SESSION_EXPIRED_EVENT, sessionExpiredListener);

                await router.isReady();

                if (authUser()) {
                    await store.dispatch('UserStore/GET_ME');
                }
            });

            return {
                loading,
            };
        },
    };
</script>
